export default {
  tagline: 'Verified keys. Instant delivery. No bullshit. A new standard in digital distribution.',
  shop: 'SHOP',
  legal: 'LEGAL',
  help: 'HELP',
  marketplace: 'Marketplace',
  catalog: 'Catalog',
  articles: 'Articles',
  terms: 'Terms',
  privacy: 'Privacy',
  cookies: 'Cookies',
  support: 'Support',
  faq: 'FAQ',
  language: 'Language',
  legalLine:
    'PixelKey Placeholder Ltd. Placeholder address, Riga, Latvia · VAT: LV40012345678 · Reg. No.: 40012345678',
  copyright: '© 2026 PixelKey. Game keys, fairly delivered.',
};
